import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import { orderBy, has, set, get, split } from 'lodash/fp';
import Pagination from '../../Pagination';
import DateCell from '../../widgets/custom-cell/Date';
import PathKeyCell from '../../widgets/custom-cell/PathKey';
import CustomHeaderCell from '../../widgets/custom-cell/HeaderCell';
import ActionCell from './ActionCell';
import DurationCell from './DurationCell';
import DurationLimitCell from './DurationLimitCell';
import SlotAvailableCell from './SlotAvailableCell';

import PaginationType from '../../../interfaces/PaginationType';

const { Column, Cell, HeaderCell } = Table;

class ReservationUpcomingEventsList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { onInit } = this.props;
    onInit();
  }

  getData() {
    const { items } = this.props;
    const { sortColumn, sortType } = this.state;
    return orderBy(sortColumn, sortType, items);
  }

  handleSortColumn = (sortColumn, sortType) => {
    const { onSort, query } = this.props;
    onSort(sortColumn, sortType, query);
  };

  handleChangePage = page => {
    const { onChangePage, loadedPages, query } = this.props;
    const isPageLoaded = has(page, loadedPages);
    const nextPageQuery = set('page', page, query);
    onChangePage(nextPageQuery, isPageLoaded);
  };

  handleChangeLimit = limit => {
    const { onChangeLimit, query } = this.props;
    const newQuery = { ...query, limit, page: 1 };
    onChangeLimit(newQuery);
  };

  renderPagination() {
    const { pagination } = this.props;
    return (
      <Pagination
        page={pagination.currentPage}
        limit={pagination.limit}
        total={pagination.totalCount}
        onChangePage={this.handleChangePage}
        onChangeLimit={this.handleChangeLimit}
      />
    );
  }

  render() {
    const { isFetching, query } = this.props;
    const [sortColumn, sortType] = split(':', get('order', query));
    return (
      <Fragment>
        <Table
          height={420}
          loading={isFetching}
          data={this.getData()}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={this.handleSortColumn}
          bordered
        >
          <Column width={90} sortable>
            <CustomHeaderCell>Date</CustomHeaderCell>
            <DateCell dataKey="outreachOn" format="MM/DD/YYYY" />
          </Column>
          <Column width={100}>
            <CustomHeaderCell>Start Time</CustomHeaderCell>
            <DateCell dataKey="outreachOn" format="hh:mm A" />
          </Column>
          <Column width={100}>
            <CustomHeaderCell>End Time</CustomHeaderCell>
            <DateCell dataKey="outreachEnd" format="hh:mm A" />
          </Column>
          <Column width={180} sortable>
            <CustomHeaderCell>Name</CustomHeaderCell>
            <Cell dataKey="name" />
          </Column>
          <Column width={160}>
            <CustomHeaderCell># of Pending Guests</CustomHeaderCell>
            <PathKeyCell dataKey="reservationCount.pending" defaultValue="0" />
          </Column>
          <Column width={160}>
            <CustomHeaderCell># of Approved Guests</CustomHeaderCell>
            <PathKeyCell dataKey="reservationCount.approved" defaultValue="0" />
          </Column>
          <Column width={180}>
            <CustomHeaderCell>Slots Limit Per Duration</CustomHeaderCell>
            <DurationLimitCell dataKey="scheduleDurationLimit" />
          </Column>
          <Column width={90}>
            <CustomHeaderCell>Duration</CustomHeaderCell>
            <DurationCell dataKey="scheduleDuration" />
          </Column>
          <Column width={120}>
            <CustomHeaderCell>Slots Available</CustomHeaderCell>
            <SlotAvailableCell dataKey="scheduleDurationLimit" />
          </Column>
          <Column width={100} fixed="right">
            <HeaderCell>Action</HeaderCell>
            <ActionCell dataKey="id" />
          </Column>
        </Table>

        {this.renderPagination()}
      </Fragment>
    );
  }
}

ReservationUpcomingEventsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFetching: PropTypes.bool.isRequired,
  onInit: PropTypes.func.isRequired,
  query: PropTypes.shape({}).isRequired,
  loadedPages: PropTypes.shape({}).isRequired,
  pagination: PaginationType.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeLimit: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired
};

export default ReservationUpcomingEventsList;
